// A secured place's balance, in the words and with the pay button the place secured page gives it
// (product/SecuredPage.jsx), so the Library's Next up and Account's Billing and My programmes say it
// the same way (member review, 11 Oct). Pure: no network and no React.
// - The amount is Stripe's, as stripe-prices answers it ("£597+vat"), never stored in the hub; a
//   balance on a recurring price, or one Stripe gives no amount for, is left out of the words.
// - The pay link is the place's own payment link (hub.my_secured_places' pay_url), with their email
//   filled in, so the balance lands on the person whose place it is.
// Members never see the word deposit: it's "your place is secured" and "the balance".

/** The amount of a product's balance from stripe-prices' answer, or null */
export function balanceAmount(balances, productId) {
  const b = (balances || []).find(x => x.product_id === productId) || null
  return b && !b.recurring && b.amount ? b.amount : null
}

/** The payment link, with their email filled in; null for anything but an https link */
export function payHref(url, email) {
  if (!url || !/^https:\/\//.test(url)) return null
  if (!email) return url
  return `${url}${url.includes('?') ? '&' : '?'}prefilled_email=${encodeURIComponent(email)}`
}

/** The pay button's words: "Pay the £597+vat balance", or "Pay the balance" without an amount */
export const payLabel = amount => (amount ? `Pay the ${amount} balance` : 'Pay the balance')
